import axios from 'axios';
import config from 'config';
import { http_client } from './api';

const getBaseUrl = () => {
  const base = config.baseApiUrl || 'http://localhost:8000/';
  return base.replace(/\/$/, '') + '/api/haunted/';
};

export const getHauntedDeviceId = () => {
  let deviceId = localStorage.getItem('haunted_device_id');
  if (!deviceId) {
    deviceId = 'dev_' + Math.random().toString(36).substring(2, 10) + '_' + Date.now();
    localStorage.setItem('haunted_device_id', deviceId);
  }
  return deviceId;
};

const hauntedClient = axios.create({
  timeout: 15000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export const hauntedService = {
  getMyGroup: async () => {
    return await http_client.get('haunted/my-group');
  },

  verifyToken: async (token) => {
    const url = getBaseUrl() + 'verify-token';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.post(url, { token, device_id });
    return res.data;
  },

  startSession: async (token) => {
    const url = getBaseUrl() + 'start';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.post(url, { token, device_id });
    return res.data;
  },

  getState: async (token) => {
    const url = getBaseUrl() + 'state';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.get(url, { params: { token, device_id }, timeout: 15000 });
    return res.data;
  },

  submitAnswer: async (token, answer) => {
    const url = getBaseUrl() + 'submit-answer';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.post(url, { token, device_id, answer });
    return res.data;
  },

  checkAnswerStatus: async (token, log_id) => {
    const url = getBaseUrl() + 'check-answer-status';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.get(url, { params: { token, device_id, log_id } });
    return res.data;
  },

  finishEscape: async (token, found_relic = false) => {
    const url = getBaseUrl() + 'finish-escape';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.post(url, { token, device_id, found_relic });
    return res.data;
  },

  surrender: async (token) => {
    const url = getBaseUrl() + 'surrender';
    const device_id = getHauntedDeviceId();
    const res = await hauntedClient.post(url, { token, device_id });
    return res.data;
  }
};

export default hauntedService;
